import { Modal } from '@mui/material';
import { Bank, CreditCard, Trash, X } from 'phosphor-react';
import React, { useEffect, useState } from 'react';
import { COLORS } from '../../../../../utils/colors';
import { AppButton } from '../../../../general/AppButton/AppButton';
import { useAppDispatch, useAppSelector } from '../../../../../redux/store';
import {
  deleteSupplierCustomerPaymentMethod,
  getSupplierCustomerPaymentMethods,
} from '../../../../../redux/services/paymentsService';
import { appDelay, Buyer, DocumentsSummary } from '@dill/dill-shared';
import AppAddPaymentMethodModal from '../../../../general/AppAddPaymentMethodModal/AppAddPaymentMethodModal';
import { openMessageModal } from '../../../../../redux/globalSlices/genericSlice';
import emptyListImg from '../../../../../assets/images/emptyList.png';
import moment from 'moment';

function SupplierCustomerPaymentMethodsModal({
  open,
  selectedCustomer,
  handleClose,
}: {
  open: boolean;
  selectedCustomer: {
    buyer: Buyer;
    usersEmailsDetails: {
      email: string;
      userId: string;
      isInvitedUser: boolean;
      isStatementsEmailOptOut: boolean;
      isPaymentRemindersEmailOptOut: boolean;
    }[];
    documentsSummary: DocumentsSummary;
  } | null;
  handleClose: () => void;
}) {
  const dispatch = useAppDispatch();
  const [isAppAddPaymentMethodModalOpen, setIsAppAddPaymentMethodModalOpen] = useState(false);
  const { supplierCustomerPaymentMethods } = useAppSelector((state) => state.payments);
  const { user } = useAppSelector((state) => state.auth);
  const currentSupplier = useAppSelector((state) => state.auth.currentSupplier);
  const getCustomerPaymentMethods = async ({ buyer }: { buyer: Buyer }) => {
    await dispatch(
      getSupplierCustomerPaymentMethods({
        supplierId: currentSupplier?.id || '',
        customerId: buyer.id,
      })
    );
  };
  const deleteCustomerPaymentMethod = async ({
    buyer,
    paymentMethodId,
  }: {
    buyer: Buyer;
    paymentMethodId: string;
  }) => {
    dispatch(
      openMessageModal({
        buttonText: 'Cancel',
        isSecondButton: true,
        secondButtonText: 'Delete',
        modalType: 'WARN',
        title: `Are you sure you want to delete this payment method?`,
        subTitle: 'This action can not be undone.',
        onSecondButtonClick: async () => {
          await appDelay(10);
          dispatch(
            openMessageModal({
              buttonText: '',
              modalType: 'LOADING',
              title: 'Deleting',
              subTitle: 'Deleting payment method',
            })
          );
          const paymentMethodDeleteResponse = await dispatch(
            deleteSupplierCustomerPaymentMethod({
              supplierId: currentSupplier?.id || '',
              customerId: buyer.id,
              paymentMethodId,
            })
          );
          if (
            paymentMethodDeleteResponse.type ===
            'payments/deleteSupplierCustomerPaymentMethod/fulfilled'
          ) {
            dispatch(
              openMessageModal({
                buttonText: 'Close',
                modalType: 'SUCCESS',
                title: 'Payment method deleted',
                subTitle: `Payment method deleted successfully`,
                onClose: () => {
                  getCustomerPaymentMethods({ buyer });
                },
              })
            );
          } else {
            let errorMessage = '';
            if (
              paymentMethodDeleteResponse.type ===
              'payments/deleteSupplierCustomerPaymentMethod/rejected'
            ) {
              errorMessage = paymentMethodDeleteResponse.payload as any;
            }
            console.log({ errorMessage });
            dispatch(
              openMessageModal({
                buttonText: 'Close',
                modalType: 'ERROR',
                title: 'Error deleting payment method',
                subTitle: `${errorMessage} Contact (628) 304-0931 for customer support`,
              })
            );
          }
        },
      })
    );
  };
  useEffect(() => {
    if (selectedCustomer) {
      getCustomerPaymentMethods({ buyer: selectedCustomer.buyer });
    }

    return () => {};
  }, [selectedCustomer]);

  return (
    <Modal
      open={open}
      onClose={() => {
        handleClose();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <div className="flex min-h-40 w-[50vw] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg  flex-col px-5 py-1">
        <AppAddPaymentMethodModal
          userType="supplier"
          paymentOptionsToShow={
            currentSupplier?.cardPaymentProvider === 'FISERV' ? 'FISERV_CARD' : 'CARD'
          }
          open={isAppAddPaymentMethodModalOpen}
          buyerDetails={selectedCustomer}
          handleClose={() => {
            setIsAppAddPaymentMethodModalOpen(false);
            if (selectedCustomer) {
              getCustomerPaymentMethods({ buyer: selectedCustomer.buyer });
            }
          }}
        />
        <div className="sticky top-0 z-10 bg-white py-2  border-b">
          <X
            size={20}
            className="absolute right-0 top-3 cursor-pointer"
            color={COLORS.GREY_500}
            onClick={() => {
              handleClose();
            }}
          />
          <h3 className="text-lg font-bold ">Customer Payment Methods</h3>
        </div>
        <div className="flex flex-col py-4  px-4">
          <div className="flex flex-col">
            <div className="flex flex-col max-h-72 overflow-y-scroll">
              {supplierCustomerPaymentMethods
                .filter((pm) => {
                  if (
                    pm.provider === 'FISERV' &&
                    currentSupplier?.cardPaymentProvider === 'FISERV'
                  ) {
                    return true;
                  }
                  if (
                    (pm.provider === 'STRIPE' &&
                      currentSupplier?.cardPaymentProvider === 'STRIPE') ||
                    (pm.provider === 'STRIPE' && !currentSupplier?.cardPaymentProvider)
                  ) {
                    return true;
                  }
                  return false;
                })
                .map((option, i) => {
                  return (
                    <div key={i + 'oo'} className="w-full px-4 my-1">
                      <button
                        className={
                          'flex flex-row w-full rounded-xl WHITE-BG px-5 py-4 border  items-center  GREY_300-BORDER relative'
                        }
                        onClick={() => {}}>
                        <div className="flex mr-2 items-center">
                          <div className="payment-type-logo">
                            {option.type === 'BANK_ACCOUNT' ? (
                              <Bank size={30} style={{ display: 'flex', alignSelf: 'center' }} />
                            ) : (
                              <CreditCard
                                size={30}
                                style={{ display: 'flex', alignSelf: 'center' }}
                              />
                            )}
                          </div>
                        </div>
                        <div className="flex flex-col">
                          <p className="text-sm font-bold text-left">{option.paymentMethodName}</p>
                          {option?.expiry && (
                            <p className="font-normal text-xs GREY_500-CLR text-left">{`Expires ${moment(
                              option.expiry,
                              option.expiry.length === 4 ? 'MMYY' : 'YYYYM'
                            ).format('MM/YY')}`}</p>
                          )}
                          {option?.user?.email && (
                            <p className="text-xs  text-left">{option?.user?.email}</p>
                          )}
                        </div>
                        <div className="absolute right-1 top-1/4 translate-y-1/2">
                          <Trash
                            size={20}
                            color={COLORS.ERROR_500}
                            onClick={() => {
                              if (selectedCustomer) {
                                deleteCustomerPaymentMethod({
                                  buyer: selectedCustomer.buyer,
                                  paymentMethodId: option.id,
                                });
                              }
                            }}
                          />
                        </div>
                      </button>
                    </div>
                  );
                })}

              {supplierCustomerPaymentMethods.length < 1 && (
                <div className="w-full h-full flex items-center justify-center">
                  <div className="flex flex-col items-center">
                    <img className="w-3/6 object-contain" src={emptyListImg} alt="" />
                    <p>No payment methods</p>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="mt-3 flex flex-col w-full ">
            <div className="self-end flex">
              <div className="mx-0.5">
                <AppButton
                  text="Close"
                  type="TERTIARY"
                  onClick={() => {
                    handleClose();
                  }}
                />
              </div>
              <div className="mx-0.5">
                <AppButton
                  text="Add New"
                  onClick={() => {
                    setIsAppAddPaymentMethodModalOpen(true);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default SupplierCustomerPaymentMethodsModal;
